import { ThemeType } from '../../../../theme/jss-types';

export const serviceTypeStyles = (theme: ThemeType) => ({
    container: {
        width: '100%',
    },
    box: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: 20,
        alignItems: 'stretch',
        boxSizing: 'border-box',
        borderRadius: 8,
        backgroundColor: '#FFFFFF',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        '@media (max-width: 768px)': {
            padding: 16,
            borderRadius: 6,
        },
    },
    referenceTitle: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 8,
        '@media (max-width: 768px)': {
            fontSize: 13,
            marginBottom: 6,
        },
    },
    line: {
        height: 1,
        margin: '8px 0px',
        width: '100%',
        backgroundColor: '#EDEDED',
        '@media (max-width: 768px)': {
            margin: '8px 0px',
        },
    },
    headerRow: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 8,
        '@media (max-width: 768px)': {
            marginBottom: 6,
            overflowX: 'auto',
            '&::-webkit-scrollbar': {
                height: 4,
            },
        },
    },
    headerCell: {
        fontSize: 12,
        fontWeight: 600,
        color: '#666666',
        fontFamily: 'Open Sans',
        textAlign: 'left',
        '@media (max-width: 768px)': {
            fontSize: 11,
        },
    },
    serviceListContainer: {
        width: '100%',
        maxHeight: 350,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: 6,
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#F5F5F5',
            borderRadius: 3,
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#CCCCCC',
            borderRadius: 3,
            '&:hover': {
                backgroundColor: '#999999',
            },
        },
        '@media (max-width: 768px)': {
            maxHeight: 300,
        },
    },
    radio: {
        display: 'flex',
        width: '100%',
        color: '#111111',
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: 0,
        padding: 12,
        borderRadius: 6,
        backgroundColor: '#FFFFFF',
        border: '1px solid #E0E0E0',
        marginBottom: 8,
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        '&:hover': {
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
        '@media (max-width: 768px)': {
            padding: 10,
            fontSize: 13,
            minHeight: 44,
            width: '100%',
        },
    },
    radioSelected: {
        backgroundColor: theme.tertiaryFillColor || '#E7F5FF',
    },
    serviceItem: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        marginRight: 0,
        fontSize: 14,
        fontWeight: 550,
        color: '#111111',
        '@media (max-width: 768px)': {
            fontSize: 13,
            fontWeight: 600,
        },
    },
    column: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        '@media (max-width: 768px)': {
            minHeight: 44,
        },
    },
    finalPrice: {
        width: '100%',
        flexDirection: 'row',
        marginRight: 0,
        fontSize: 12,
        fontWeight: 500,
        color: '#333333',
        display: 'flex',
        textAlign: 'left',
        '@media (max-width: 768px)': {
            fontSize: 11,
        },
    },
    tat: {
        width: '100%',
        fontSize: 12,
        fontWeight: 500,
        color: '#333333',
        '@media (max-width: 768px)': {
            fontSize: 11,
        },
    },
    deliveryTime: {
        width: '100%',
        fontSize: 12,
        fontWeight: 500,
        color: '#333333',
        '@media (max-width: 768px)': {
            fontSize: 11,
        },
    },
    loadingOverlay: {
        position: 'relative',
        minHeight: 200,
    },
});

